import amazonProductApi from '@/api/amazonProduct';
import { loadEntity, enhanceOrAdd } from '@/helpers/utility';

const state = {
    byId: {},
};

const actions = {
    async searchAmazonProducts(store, { term }) {
        let response = await amazonProductApi.wishlistSearch(term);
        return loadEntity({ amazonProducts: response.data });
    },
};

const mutations = {
    LOAD_ENTITIES(state, { amazonProducts }) {
        if (amazonProducts)
            Object.values(amazonProducts).forEach(amazonProduct => enhanceOrAdd(state.byId, amazonProduct.id, _.pickBy(amazonProduct)));
    },
    UPDATE_AMAZONPRODUCT(state, { amazonProduct }) {
        enhanceOrAdd(state.byId, amazonProduct.id, amazonProduct)
    },
};

export default {
    state,
    actions,
    mutations,
};
